import { createCreateButton } from '../../../../components/CreateButton'
import translations from './LabelCreateButton.i18n.json'
import { UpsertLabelModal } from '../UpsertLabel/UpsertLabelModal'

export const LabelCreateButton = createCreateButton({
  UpsertModal: UpsertLabelModal,
  translations,
})
